import ApplicationController from "../application_controller";

export default class SubmitController extends ApplicationController<HTMLButtonElement> {
  static targets = ["submittingIcon"];
  static values = { isSubmitting: Boolean };

  declare readonly submittingIconTarget: HTMLElement;
  declare isSubmittingValue: boolean;

  isSubmittingValueChanged(currentValue: boolean, previousValue: boolean) {
    // Set the button to disabled while submitting
    if (currentValue) {
      this.element.disabled = true;
      this.submittingIconTarget.removeAttribute("hidden");
    }
    // Reset the button to active if it was disabled due to submitting
    if (previousValue && !currentValue) {
      this.element.disabled = false;
      this.submittingIconTarget.toggleAttribute("hidden", true);
    }
  }
}
